<template>
    <BCard no-body>
      <BCardHeader class="pb-50">
        <h5> {{$t("Filters")}} </h5>
      </BCardHeader>
      <BCardBody>
        <BRow>
          <BCol cols="12" md="6" class="mb-md-0 mb-2" >
            <label>{{$t('Family')}}</label>
            <vSelect v-model="familyFilter" :options="families" label="name" class="w-100" :reduce="val => val.id" />
          </BCol>
          <BCol cols="12" md="6" class="mb-md-0 mb-2" >
            <label>{{$t('Tax')}}</label>
            <vSelect v-model="taxFilter" :options="taxes" label="name" class="w-100" :reduce="val => val.id" />
          </BCol>
        </BRow>
      </BCardBody>
    </BCard>
  </template>

  <script>
  import { BCard, BCardHeader, BCardBody, BRow, BCol } from 'bootstrap-vue'
  import { inject } from '@vue/composition-api';
  import vSelect from 'vue-select'

  export default {
    components: { BRow, BCol, BCard, BCardHeader, BCardBody, vSelect, },
    setup(){
        const familyFilter = inject('familyFilter')
        const taxFilter = inject('taxFilter')
        const families = inject('families')
        const taxes = inject('taxes')

        return {
            familyFilter,
            taxFilter,
            families,
            taxes
        }
    }
  }
  </script>

  <style lang="scss">
  @import '~@core/scss/vue/libs/vue-select.scss';
  </style>
